import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { loadTranslations } from "@/i18n";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));

// The texts come from the API, so render only once they are loaded.
loadTranslations()
  .then(() =>
    root.render(
      <React.StrictMode>
        <QueryClientProvider client={queryClient}>
          <App />
        </QueryClientProvider>
      </React.StrictMode>,
    ),
  )
  .catch(() => {
    // without the API there are no texts either; this one line is the only fallback
    root.render(<p style={{ padding: 24, fontFamily: "sans-serif" }}>Faqja nuk mund të ngarkohet tani. Ju lutemi provoni përsëri më vonë.</p>);
  });
